/** Data-widget series colours. Canvas renderers require literal colours.
 * Positive/negative slots resolve through useChartColors so they follow the app theme.
 * Axis, grid and tooltip colours belong to lib/charts/chart-tokens.ts.
 */
export const DATA_CHART_COLORS = {
  cyan: '#18e2f4',
  lightBlue: '#7cd0e8',
  teal: '#76c4d0',
  deepTeal: '#2c7691',
  amber: '#F59E0B',
  purple: '#A78BFA',
  spot: '#F5F7FA',
  reference: '#A1A1A6',
} as const

export const DATA_CHART_LINE_PALETTE = [
  'mint',
  DATA_CHART_COLORS.cyan,
  DATA_CHART_COLORS.lightBlue,
  DATA_CHART_COLORS.teal,
  DATA_CHART_COLORS.deepTeal,
  'red',
  DATA_CHART_COLORS.amber,
] as const

export const DATA_CHART_IVR_PALETTE = [...DATA_CHART_LINE_PALETTE, DATA_CHART_COLORS.spot] as const

// Preserve the surface's expiry-colour order, including its extra purple slot.
export const DATA_CHART_SURFACE_LINE_PALETTE = [
  ...DATA_CHART_LINE_PALETTE.slice(0, 4),
  'red',
  DATA_CHART_COLORS.amber,
  DATA_CHART_COLORS.purple,
  DATA_CHART_COLORS.deepTeal,
] as const

/** Low → high volatility, independent of the categorical line palette. */
export const DATA_CHART_SURFACE_GRADIENT = ['#2c5aa0', '#7ec8e3', '#f2ead2', '#f2a154', '#c0392b']

export const DATA_CHART_SESSION_COLORS = {
  APAC: 'mint',
  EU: DATA_CHART_COLORS.cyan,
  US: 'red',
} as const

/** Rate-tree categories retain their existing eight-colour rotation. */
export const DATA_CHART_FEDWATCH_PALETTE = [
  '#00B68F',
  DATA_CHART_COLORS.cyan,
  '#7c9cff',
  '#c084fc',
  '#f472b6',
  '#fb923c',
  '#facc15',
  '#94a3b8',
] as const
